import create from 'zustand'
import { devtools } from 'zustand/middleware'

export type CameraInputMethods = 'Drag' | 'Gyro' | 'Both' | 'None'

export interface MoveState {
  movementIsLocked: boolean
  lockMovement: () => void,
  unlockMovement: () => void,
  animationStep: number,
  increaseAnimationStep: () => void,
  resetAnimationStep: () => void,
}

export const useMoveStore = create<MoveState>()(
  devtools(
    (set) => ({
      movementIsLocked: false,
      lockMovement: () => set(() => ({ movementIsLocked: true })),
      unlockMovement: () => set(() => ({ movementIsLocked: false })),
      animationStep: 0,
      increaseAnimationStep: () => set((state) => ({ animationStep: state.animationStep + 1 })),
      resetAnimationStep: () => set(() => ({ animationStep: 0 }))
    }),
    {
      name: 'move-storage'
    }
  )
)
